import MUIDialog, { DialogProps as MUIDialogProps } from '@mui/material/Dialog';

export interface DialogProps extends MUIDialogProps {}

export const Dialog = MUIDialog;
